export default {
	Reply: 'پاسخ',
	'Delete comment': 'حذف نظر',
	'Are you sure you want to delete this comment? You cannot undo this action.': 'آیا مطمئن هستید که می‌خواهید این نظر را حذف کنید؟ این عمل غیرقابل بازگشت است.',
	Delete: 'حذف',
	'Enter keyword to search': 'کلمه کلیدی برای جستجو وارد کنید',
	Keyword: 'کلمه کلیدی',
	'Revert new changes': 'بازگشت به تغییرات جدید',
	'Filter posts by': 'فیلتر کردن پست‌ها بر اساس',
	'Comments/asc': 'نظرات/صعودی',
	'Member since': 'عضو از',
	Next: 'بعدی',
	Previous: 'قبلی',
	Prev: 'قبلی',
	Clear: 'پاک کردن',
	'View all': 'مشاهده همه',
	'Password reset link sent': 'لینک بازنشانی رمز عبور ارسال شد',
	'A password reset link has been sent to your email!': 'لینک بازنشانی رمز عبور به ایمیل شما ارسال شد!',
	'Add elsewhere links to your profile.': 'لینک‌های دیگری به پروفایل خود اضافه کنید.',
	'Social settings': 'تنظیمات شبکه‌های اجتماعی',
	'Confirm password': 'تأیید رمز عبور',
	'Password must be at least 6 characters': 'رمز عبور باید حداقل ۶ کاراکتر باشد',
	'New password': 'رمز عبور جدید',
	'Update your password.': 'رمز عبور خود را به‌روزرسانی کنید.',
	'Password settings': 'تنظیمات رمز عبور',
	Website: 'وب‌سایت',
	'A short Bio (e.g. occupation), this will show up in the author cards': 'یک بیوگرافی کوتاه (مثلاً شغل)، این در کارت‌های نویسنده نمایش داده می‌شود',
	'Short Bio': 'بیوگرافی کوتاه',
	'Something about yourself in a few word': 'چند کلمه‌ای درباره خودتان',
	'Biographical Info, this will show up in the author page': 'اطلاعات بیوگرافی، این در صفحه نویسنده نمایش داده می‌شود',
	'Biographical Info': 'اطلاعات بیوگرافی',
	required: 'ضروری',
	Nickname: 'نام مستعار',
	'Last Name': 'نام خانوادگی',
	'First Name': 'نام',
	'Cover photo': 'عکس کاور',
	'Profile picture': 'عکس پروفایل',
	'Profile settings': 'تنظیمات پروفایل',
	'Display Name': 'نام نمایشی',
	'Update your username and manage your account': 'نام کاربری خود را به‌روزرسانی کنید و حساب خود را مدیریت کنید',
	'General settings': 'تنظیمات عمومی',
	'Returning to the home page!': 'در حال بازگشت به صفحه اصلی!',
	'Account deleted successfully!': 'حساب با موفقیت حذف شد!',
	'in the box below': 'در کادر زیر',
	'To confirm, type': 'برای تأیید، تایپ کنید',
	'Delete your account and all data. This action is irreversible.': 'حساب و تمامی داده‌های خود را حذف کنید. این عمل غیرقابل بازگشت است.',
	'Update profile': 'به‌روزرسانی پروفایل',
	'A password reset link has been sent to your email': 'لینک بازنشانی رمز عبور به ایمیل شما ارسال شد',
	or: 'یا',
	'Please check your email to complete the registration process': 'لطفاً ایمیل خود را برای تکمیل فرآیند ثبت‌نام بررسی کنید',
	'Something went wrong while creating user account!': 'مشکلی در هنگام ایجاد حساب کاربری رخ داده است!',
	'Jump to...': 'برو به...',
	'Search posts': 'جستجوی پست‌ها',
	'Search authors': 'جستجوی نویسندگان',
	'Search categories': 'جستجوی دسته‌ها',
	'Recommended searches': 'جستجوهای پیشنهادی',
	Explore: 'کاوش',
	'Go to search page': 'برو به صفحه جستجو',
	'By creating an account you agree with our': 'با ایجاد یک حساب کاربری، با قوانین ما موافقت می‌کنید',
	'Privacy Policy': 'سیاست حفظ حریم خصوصی',
	'A list of all your posts. Let’s get you some views! 🚀': 'لیست تمامی پست‌های شما. بیایید برخی بازدیدها بگیرید! 🚀',
	Posts: 'پست‌ها',
	Post: 'پست',
	Likes: 'پسندها',
	Views: 'بازدیدها',
	Saveds: 'ذخیره‌شده‌ها',
	Comments: 'نظرات',
	'Load more': 'بارگذاری بیشتر',
	Published: 'منتشر شده',
	Pending: 'در انتظار',
	Scheduled: 'برنامه‌ریزی شده',
	Draft: 'پیش‌نویس',
	Trash: 'زباله‌دان',
	General: 'عمومی',
	Profile: 'پروفایل',
	Socials: 'شبکه‌های اجتماعی',
	'Delete account': 'حذف حساب',
	Documents: 'اسناد',
	'Sign out': 'خروج',
	'Back to home': 'بازگشت به خانه',
	'Please fill all fields': 'لطفاً تمامی فیلدها را پر کنید',
	Message: 'پیام',
	'Send Message': 'ارسال پیام',
	'Full name': 'نام کامل',
	'Email address': 'آدرس ایمیل',
	'Drop us message and we will get back for you.': 'پیامی برای ما بگذارید و ما به شما پاسخ خواهیم داد.',
	'Contact us': 'تماس با ما',
	Contact: 'تماس',
	Edit: 'ویرایش',
	Home: 'خانه',
	'Reset password': 'بازنشانی رمز عبور',
	Width: 'عرض',
	Height: 'ارتفاع',
	Replace: 'جایگزین کردن',
	Remove: 'حذف کردن',
	Email: 'ایمیل',
	'Email and password are required!': 'ایمیل و رمز عبور ضروری هستند!',
	'Email and username are required!': 'ایمیل و نام کاربری ضروری هستند!',
	'Email or username are required!': 'ایمیل یا نام کاربری ضروری هستند!',
	'Email are required!': 'ایمیل ضروری است!',
	'Enter your email': 'ایمیل خود را وارد کنید',
	Password: 'رمز عبور',
	'Sign up': 'ثبت‌نام',
	'Sign in': 'ورود',
	'Already have an account?': 'قبلاً حساب کاربری دارید؟',
	Login: 'ورود',
	'Username and password are required!': 'نام کاربری و رمز عبور ضروری هستند!',
	Username: 'نام کاربری',
	'Email or username': 'ایمیل یا نام کاربری',
	'Not a member?': 'عضو نیستید؟',
	'Lost your password?': 'رمز عبور خود را فراموش کرده‌اید؟',
	'Reading list': 'لیست مطالعه',
	'Show me more': 'مطالب بیشتر',
	Tags: 'برچسب‌ها',
	'Edit image': 'ویرایش تصویر',
	'Delete image': 'حذف تصویر',
	Cancel: 'لغو',
	Apply: 'اعمال',
	Image: 'تصویر',
	Create: 'ایجاد',
	'Please wait a moment, data is being prepared.': 'لطفاً کمی صبر کنید، داده‌ها در حال آماده‌سازی هستند.',
	'Edit profile': 'ویرایش پروفایل',
	'My Posts': 'پست‌های من',
	Wishlist: 'لیست علاقه‌مندی‌ها',
	'Dark theme': 'تم تاریک',
	Help: 'راهنما',
	Helps: 'راهنماها',
	'Log out': 'خروج',
	'Type to search...': 'برای جستجو تایپ کنید...',
	'Newtest to oldest': 'جدیدترین به قدیمی‌ترین',
	'Oldest to newest': 'قدیمی‌ترین به جدیدترین',
	'A to Z': 'الف تا ی',
	'Z to A': 'ی تا الف',
	'Most comments': 'بیشترین نظرات',
	'Most views': 'بیشترین بازدیدها',
	'Most likes': 'بیشترین پسندها',
	Category: 'دسته‌بندی',
	Other: 'دیگر',
	'Discover other tags': 'برچسب‌های دیگر را کشف کنید',
	Categories: 'دسته‌ها',
	'Other categories': 'دسته‌های دیگر',
	'Other tags': 'برچسب‌های دیگر',
	'Discover other categories': 'دسته‌های دیگر را کشف کنید',
	Articles: 'مقالات',
	Authors: 'نویسندگان',
	'Favorites list': 'لیست علاقه‌مندی‌ها',
	Bookmarks: 'نشانک‌ها',
	'Sign in to your account': 'وارد حساب خود شوید',
	'Copy link': 'کپی کردن لینک',
	'Link copied to clipboard': 'لینک به کلیپ‌بورد کپی شد',
	Submit: 'ارسال',
	'Something went wrong': 'مشکلی پیش آمد',
	'Please try again later': 'لطفاً بعداً دوباره امتحان کنید',
	'Network error': 'خطای شبکه',
	'GraphQL error': 'خطای GraphQL',
	'Loading ...': 'در حال بارگذاری ...',
	Refetch: 'دوباره دریافت کردن',
	'Comment this post': 'نظر دادن به این پست',
	'Edit post': 'ویرایش پست',
	'Publish post': 'انتشار پست',
	'Move to Pending': 'انتقال به در انتظار',
	'Move to trash': 'انتقال به زباله‌دان',
	'Post updated': 'پست به‌روزرسانی شد',
	'Updating post...': 'در حال به‌روزرسانی پست...',
	'Updating post, please wait!': 'در حال به‌روزرسانی پست، لطفاً صبر کنید!',
	pageSingle: {
		'WRITTEN BY': 'نوشته شده توسط',
		'Show more comments': 'نمایش نظرات بیشتر',
		Responses: 'پاسخ‌ها',
		'You must login to comment': 'برای نظر دادن باید وارد شوید',
		'Add to discussion': 'افزودن به بحث',
	},
	pageSubmission: {
		'Revert new changes': 'بازگشت به تغییرات جدید',
		'Choose the post style. Only applies to Standard format!': 'سبک پست را انتخاب کنید. فقط برای فرمت استاندارد اعمال می‌شود!',
		'Post style': 'سبک پست',
		'Show right sidebar': 'نمایش نوار کناری راست',
		'Alt text (alternative text)': 'متن جایگزین (متن Alt)',
		'Image URL': 'آدرس URL تصویر',
		'Youtube URL': 'آدرس URL یوتیوب',
		'Update post successfully': 'پست با موفقیت به‌روزرسانی شد',
		'Created new post successfully': 'پست جدید با موفقیت ایجاد شد',
		'Move to draft': 'انتقال به پیش‌نویس',
		'Save draft': 'ذخیره پیش‌نویس',
		'Congratulations! You have successfully updated the post!': 'تبریک! شما پست را با موفقیت به‌روزرسانی کردید!',
		'These changes will be applied to the post in about 15 minutes.': 'این تغییرات در حدود ۱۵ دقیقه به پست اعمال خواهند شد.',
		'You can': 'شما می‌توانید',
		'preview the post': 'پیش‌نمایش پست',
		'by clicking the button below.': 'با کلیک بر روی دکمه زیر.',
		'Preview post': 'پیش‌نمایش پست',
		Schedule: 'زمان‌بندی',
		Publish: 'انتشار',
		'Featured image': 'تصویر ویژه',
		'New post title here…': 'عنوان پست جدید در اینجا...',
		'Remove category': 'حذف دسته‌بندی',
		'Add categories': 'افزودن دسته‌بندی‌ها',
		Categories: 'دسته‌ها',
		'Load more categories': 'بارگذاری بیشتر دسته‌ها',
		'Add tags': 'افزودن برچسب‌ها',
		'Add tag': 'افزودن برچسب',
		'Load more tags': 'بارگذاری بیشتر برچسب‌ها',
		'Write your post content here…': 'محتوای پست خود را اینجا بنویسید...',
		'The url is not an image, please try again.': 'آدرس وارد شده یک تصویر نیست، لطفاً دوباره امتحان کنید.',
		'Upload a file': 'بارگذاری یک فایل',
		Re: 'بارگذاری یک فایل',
		'Paste or type URL': 'آدرس URL را چسبانده یا تایپ کنید',
		'Sorry this feature is not available yet. Please use the URL option.': 'متأسفانه این ویژگی هنوز در دسترس نیست. لطفاً از گزینه URL استفاده کنید.',
		'Post options': 'گزینه‌های پست',
		'Post format': 'فرمت پست',
		'Gallery images': 'تصاویر گالری',
		'Write an excerpt (optional)': 'یک گزیده بنویسید (اختیاری)',
		'Schedule Publication': 'زمان‌بندی انتشار',
		'Video URL (Youtube, Vimeo, mp4 ... )': 'آدرس URL ویدیو (یوتیوب، ویمئو، mp4 ...)',
		'Video url...': 'آدرس ویدیو...',
		'Audio url...': 'آدرس صدا...',
		'Allow comments': 'اجازه نظرات',
		'Unset link': 'لغو لینک',
		'Type the URL of the iframe you want to embed': 'آدرس URL iframeی که می‌خواهید تعبیه کنید را وارد کنید',
		'Iframe URL': 'آدرس URL iframe',
		'Draft this post': 'پیش‌نویس این پست',
		'Post will be changed to draft. You can publish it later.': 'پست به پیش‌نویس تبدیل خواهد شد. می‌توانید آن را بعداً منتشر کنید.',
	},
	pageSearch: {
		'Type and press enter': 'تایپ کنید و اینتر بزنید',
		Recommended: 'پیشنهادی',
	},
}
